import { CCard } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarCard = (props) => {
  const { children } = props
  return <CCard {...props}>{children}</CCard>
}

export { ConfiaCarCard }
